import React, { Fragment } from "react"
import { FormLabel, LabelWrapper } from "./inputtextStyle";
import { InputText } from 'primereact/inputtext';
import PropTypes from 'prop-types';

function Forminputtext({ label, name, type, value, required, onChange, ...rest }) {
    return (<Fragment>
        <LabelWrapper>
            <FormLabel>{label}{" "}
            {required?<span
                style={{
                  color: "#f10000",
                }}
              >
                *
              </span>:""}
              </FormLabel>
        </LabelWrapper>

        <InputText
            name={name}
            type={type}
            placeholder={"Enter " + label}
            value={value}
            onChange={(e) => onChange(e)}
            required={required}
            variant="filled"
            {...rest}
           
            
        />
    </Fragment>)
}
export default Forminputtext;